import { render, staticRenderFns } from "./sala.vue?vue&type=template&id=0cd43d4a&scoped=true&"
import script from "./sala.vue?vue&type=script&lang=js&"
export * from "./sala.vue?vue&type=script&lang=js&"
import style0 from "./sala.vue?vue&type=style&index=0&id=0cd43d4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd43d4a",
  null
  
)

export default component.exports